import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getConfig } from 'utils';

export const signIn = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({

            method: "post",
            url: getConfig.API_URL + 'user_login',
            data: {
                "user_name": data?.phone,
                "password": data?.password
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const verifyOtp = createAsyncThunk('VerifyOtp', async ({ user_id, user_name, otp }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'verify_otp',
            data: {
                "user_id": user_id,
                "user_name": user_name,
                "user_otp": otp
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const forgotPasswordSendOtp = createAsyncThunk('ForgotPasswordSendOtp', async ({ user_name, verification_method }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'reset_request',
            data: {
                user_name,
                verification_method
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const forgotPasswordVerifyOtp = createAsyncThunk('ForgotPasswordVerifyOtp', async ({ user_name, user_otp, verification_method }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'reset_verify_otp',
            data: {
                user_name,
                user_otp,
                verification_method
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const forgotPasswordReset = createAsyncThunk('ForgotPasswordReset', async ({ user_name, user_otp, verification_method, user_password }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'reset_password',
            data: {
                user_name,
                user_otp,
                verification_method,
                user_password
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const signInSlice = createSlice({
    name: 'signIn',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(signIn.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else {
                state.data = null;
            }

        });
        builder.addCase(signIn.rejected, (state, action) => {
            // console.log('reject', action)
        })

        builder.addCase(verifyOtp.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else {
                state.data = null;
            }

        });
        builder.addCase(verifyOtp.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default signInSlice.reducer;